<template>
  <div class="page-container hunters-container">
    <todo-side-bar selected="hunters" />

    <h1>{{ $t('pages.providers' ) }}</h1>

    <el-row type="flex" class="hunters-content">
      <el-col :span="16" class="col-left">
        <ts-providers :selected="provider" @provider-change="changeProvider" />
      </el-col>
      <el-col :span="8" class="col-right">
        <ts-hunters v-if="!provider" />
        <ts-provider v-if="provider" :provider="provider" @close="provider = null" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Providers from './components/Providers.vue'
  import Hunters from './components/Hunters.vue'
  import Provider from './components/Provider.vue'

  export default {
    components: {
      'ts-providers': Providers,
      'ts-hunters': Hunters,
      'ts-provider': Provider
    },

    data() {
      return {
        provider: null
      }
    },

    methods: {
      changeProvider(provider) {
        this.provider = provider
      }
    }
  }
</script>

<style lang="scss">
  .hunters-container {
    .hunters-content {
      position: absolute;
      top: 80px;
      left: 230px;
      right: 40px;
      bottom: 20px;

      .col-left {
        position: relative;
        border-right: 1px solid #E0E0E0;
        padding-right: 15px;
        padding-top: 50px;
      }

      .col-right {
        position: relative;
        margin-left: 40px;
      }
    }
  }
</style>
